import { Rpc } from '../rpc';
import { RpcObservableServer } from '../rpc-observable-server';
import {
    RpcObservableErrorMonitorError, RpcObservableErrorMonitorKey, RpcObservableErrorMonitorRequest, RpcObservableErrorMonitorResult
} from './rpc-observable-error-monitor-model';

export class RpcObservableErrorMonitorServer
    extends RpcObservableServer<RpcObservableErrorMonitorRequest, RpcObservableErrorMonitorResult, RpcObservableErrorMonitorError> {

    /**
     * Initializes a new instance of the RpcObservableErrorMonitorServer class.
     *
     * @param rpc the rpc object.
     */
    constructor(rpc: Rpc) {
        super(rpc, RpcObservableErrorMonitorKey.command, RpcObservableErrorMonitorKey.version);
    }
}
